export interface LimitExceptionsUploadErrorItem {
  rowNumber: number;
  errorCode: string;
  errorMessage: string;
}

export interface LimitExceptionsUploadResponse {
  totalRowsReceived: number;
  totalRowsProcessedSuccessfully: number;
  totalRowsRejected: number;
  errors: LimitExceptionsUploadErrorItem[];
}

export const ACCEPT_EXCEL_EXTENSIONS = '.xlsx, .xls';
export const EXCEL_EXTENSION_REGEX = /\.(xlsx|xls)$/i;
